/* KidSenta theme scripts (no dependencies) */
(function () {
  'use strict';
  var G = window.Glovebox || {};
  var R = G.routes || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };

  function money(cents) {
    var fmt = G.moneyFormat || '${{amount}}';
    var v = (cents / 100).toFixed(2);
    var withCommas = v.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, withCommas.split('.')[0])
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, v.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withCommas)
      .replace(/<[^>]*>/g, '');
  }

  var toastTimer;
  function toast(msg) {
    var t = $('#Toast');
    if (!t) { t = document.createElement('div'); t.id = 'Toast'; t.className = 'toast'; t.setAttribute('role', 'status'); document.body.appendChild(t); }
    t.textContent = msg; t.hidden = false; clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { t.hidden = true; }, 2600);
  }

  /* Announcement rotator */
  $$('[data-rotator]').forEach(function (bar) {
    var msgs = $$('.topbar__msg', bar); if (msgs.length < 2) return;
    var i = 0;
    setInterval(function () { msgs[i].classList.remove('is-active'); i = (i + 1) % msgs.length; msgs[i].classList.add('is-active'); }, 4500);
  });

  /* Drawers */
  var menu = $('[data-drawer]');
  function lock(on) { document.body.classList.toggle('no-scroll', on); }
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open); menu.setAttribute('aria-hidden', open ? 'false' : 'true'); lock(open);
    if (open) { var b = $('[data-drawer-close].icon-btn', menu); b && b.focus(); }
  }
  function cartDrawer() { return $('[data-cart-drawer]'); }
  function setCart(open) {
    var d = cartDrawer(); if (!d) return false;
    d.classList.toggle('is-open', open); d.setAttribute('aria-hidden', open ? 'false' : 'true'); lock(open);
    if (open) { var b = $('[data-cart-close].icon-btn', d); b && b.focus(); }
    return true;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-open]')) { e.preventDefault(); setMenu(true); }
    else if (e.target.closest('[data-drawer-close]')) { e.preventDefault(); setMenu(false); }
    else if (menu && menu.classList.contains('is-open') && e.target.closest('[data-drawer] a')) { setMenu(false); }
    else if (e.target.closest('[data-cart-open]')) {
      if (document.body.classList.contains('template-cart')) return;
      if (setCart(true)) e.preventDefault();
    }
    else if (e.target.closest('[data-cart-close]')) { e.preventDefault(); setCart(false); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { setMenu(false); setCart(false); } });

  /* Cart */
  function updateCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; el.hidden = n === 0; });
  }
  function refreshDrawer() {
    return fetch((R.root || '/') + '?sections=cart-drawer').then(function (r) { return r.json(); }).then(function (data) {
      var html = data && data['cart-drawer']; var d = cartDrawer();
      if (!html || !d) return;
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = $('[data-cart-drawer]', tmp);
      if (fresh) d.innerHTML = fresh.innerHTML;
    });
  }
  function refreshCount() {
    return fetch((R.cart_url || '/cart') + '.js').then(function (r) { return r.json(); }).then(function (c) { updateCount(c.item_count); return c; });
  }
  function changeLine(line, qty) {
    var d = cartDrawer(); d && d.classList.add('is-loading');
    return fetch((R.cart_change_url || '/cart/change') + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
    }).then(function (r) { return r.json(); }).then(function (c) {
      updateCount(c.item_count);
      if (document.body.classList.contains('template-cart')) { window.location.reload(); return; }
      return refreshDrawer();
    }).finally(function () { d && d.classList.remove('is-loading'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty-to]'); if (!b) return;
    e.preventDefault();
    changeLine(parseInt(b.dataset.line, 10), parseInt(b.dataset.qtyTo, 10));
  });

  function addToCart(form, btn) {
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-busy'); }
    return fetch((R.cart_add_url || '/cart/add') + '.js', {
      method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (d) { if (!r.ok) throw d; return d; });
    }).then(function () {
      var err = form.querySelector('.form-error'); if (err) err.remove();
      if (btn) { btn.classList.add('is-added'); btn.innerHTML = 'Added to cart'; }
      return Promise.all([refreshCount(), refreshDrawer()]);
    }).then(function () {
      var openDrawer = document.documentElement.dataset.openDrawer !== 'false';
      if (openDrawer && cartDrawer()) setCart(true); else toast('Added to cart');
      if (btn) setTimeout(function () { btn.classList.remove('is-added'); btn.innerHTML = label; }, 1600);
    }).finally(function () {
      if (btn) { btn.disabled = false; btn.classList.remove('is-busy'); }
    });
  }
  function showError(form, err) {
    var msg = (err && (err.description || err.message)) || 'This item could not be added. Refresh the page and try again.';
    var el = form.querySelector('.form-error');
    if (!el) { el = document.createElement('p'); el.className = 'form-error errors small'; el.setAttribute('role', 'alert'); form.appendChild(el); }
    el.textContent = msg;
  }
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-ajax-cart], [data-product-form]')) return;
    e.preventDefault();
    var btn = $('[type="submit"]', form);
    addToCart(form, btn).catch(function (err) { if (btn) btn.innerHTML = btn.dataset.label || 'Add to cart'; showError(form, err); });
  });

  /* Quantity steppers */
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-step]'); if (!b) return;
    var input = b.parentElement.querySelector('input');
    input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.dataset.step, 10));
  });

  /* Product page */
  $$('[data-product]').forEach(function (root) {
    var jsonEl = $('[data-product-json]', root);
    var data = jsonEl ? JSON.parse(jsonEl.textContent) : null;
    var form = $('[data-product-form]', root);
    var idInput = $('[data-variant-id]', root);
    var mainImg = $('[data-main-image]', root);
    var thumbs = $$('[data-thumb]', root);
    var arts = $$('[data-art-for]', root);
    var sticky = $('[data-sticky-buy]', root);

    function showImage(src, btn) {
      if (!mainImg || !src) return;
      mainImg.src = src; mainImg.removeAttribute('srcset');
      thumbs.forEach(function (t) { t.classList.toggle('is-active', t === btn); });
    }
    thumbs.forEach(function (t) {
      t.addEventListener('mouseenter', function () { showImage(t.dataset.src, t); });
      t.addEventListener('click', function () { showImage(t.dataset.src, t); });
    });

    function priceHTML(v) {
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var h = '<div class="price price--large" data-price><span class="price__now' + (sale ? ' is-sale' : '') + '">' + money(v.price) + '</span>';
      if (sale) h += '<s class="price__was">' + money(v.compare_at_price) + '</s><span class="save-pill">You save ' + money(v.compare_at_price - v.price) + '</span>';
      return h + '</div>';
    }

    function update() {
      if (!data) return;
      var opts = $$('.opt', root).map(function (fs) { var s = $('.opt__btn.is-selected', fs); return s ? s.dataset.optionValue : null; });
      var v = data.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      var addBtn = $('[data-add-btn]', root), buyBtn = $('[data-buy-now]', root), sAdd = $('[data-sticky-add]', root);
      if (!v) {
        [addBtn, buyBtn, sAdd].forEach(function (b) { if (b) b.disabled = true; });
        if (addBtn) addBtn.textContent = 'Unavailable';
        return;
      }
      idInput.value = v.id;
      $$('[data-price-wrap]', root).forEach(function (w) { w.innerHTML = priceHTML(v); });
      var sp = $('[data-sticky-price]', root); if (sp) sp.textContent = money(v.price);
      [addBtn, buyBtn, sAdd].forEach(function (b) { if (b) b.disabled = !v.available; });
      if (addBtn) addBtn.textContent = v.available ? 'Add to cart' : 'Sold out';
      if (v.featured_image && v.featured_image.src) {
        var src = v.featured_image.src;
        showImage(src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=1100', null);
      }
      arts.forEach(function (a) { a.hidden = a.dataset.artFor !== v.title; });
      var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    }

    $$('.opt', root).forEach(function (fs) {
      fs.addEventListener('click', function (e) {
        var b = e.target.closest('.opt__btn'); if (!b) return;
        $$('.opt__btn', fs).forEach(function (s) { var on = s === b; s.classList.toggle('is-selected', on); s.setAttribute('aria-pressed', on ? 'true' : 'false'); });
        var lbl = $('[data-option-label]', fs); if (lbl) lbl.textContent = b.dataset.optionValue;
        update();
      });
    });

    var buy = $('[data-buy-now]', root);
    if (buy && form) {
      buy.addEventListener('click', function () {
        buy.disabled = true;
        fetch((R.cart_add_url || '/cart/add') + '.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); })
          .then(function () { window.location.href = '/checkout'; })
          .catch(function (err) { buy.disabled = false; showError(form, err); });
      });
    }

    var sAdd = $('[data-sticky-add]', root);
    if (sAdd && form) sAdd.addEventListener('click', function () { addToCart(form, null).catch(function (err) { showError(form, err); }); });
    if (sticky && form && 'IntersectionObserver' in window) {
      var addBtnEl = $('[data-add-btn]', root);
      new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
      }).observe(addBtnEl);
    }

    var d = $('[data-delivery]', root);
    if (d) {
      var addBiz = function (date, n) { var x = new Date(date); while (n > 0) { x.setDate(x.getDate() + 1); var w = x.getDay(); if (w !== 0 && w !== 6) n--; } return x; };
      var fmt = function (x) { return x.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' }); };
      var a = $('[data-d-arrive]', d), today = new Date();
      if (a) a.textContent = fmt(addBiz(today, +d.dataset.min || 7)) + ' – ' + fmt(addBiz(today, +d.dataset.max || 14));
    }
  });

  /* Collection sort / filters */
  $$('[data-sort-select]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sel.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });
  $$('[data-facet-input]').forEach(function (inp) { inp.addEventListener('change', function () { inp.form.submit(); }); });
  $$('[data-toggle-filters]').forEach(function (b) {
    b.addEventListener('click', function () { var p = $('[data-filters-panel]'); p && p.classList.toggle('is-open'); });
  });
  $$('[data-show-recover]').forEach(function (a) {
    a.addEventListener('click', function () { var r = $('#Recover'); r && r.classList.add('is-visible'); });
  });

  /* Hero: play the footstep trail once when visible */
  var scene = $('.ks-scene');
  if (scene) {
    var play = function () { scene.classList.add('is-playing'); };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (en) { if (en[0].isIntersecting) { play(); io.disconnect(); } }, { threshold: .35 });
      io.observe(scene);
    } else play();
  }
})();
